import styled, { css } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export const Container = styled.div``;

export const SpinnerWrap = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Spinner = styled(AiOutlineLoading3Quarters)`
  animation: spinerAnimate 1.5s linear infinite;
`;

export const DescriptionContainer = styled.div`
  margin-top: 2px;
  padding: 24px 4px;
`;

export const DescriptionTitle = styled.h1`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 37px;
  color: #0b29fb;
  @media (max-width: 600px) {
    text-align: center;
  }
`;

export const DescriptionText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #3d3d3d;
  display: inline-block;
  max-width: 600px;

  @media (max-width: 600px) {
    text-align: center;
    font-size: 12px;
  }
`;

export const PageIntroBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
  max-width: 600px;

  @media (max-width: 600px) {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const WhatsAppOnlyContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const WhatsAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
  padding: 10px 16px;
  border: 1px solid #0b29fb;
  border-radius: 8px;
  background: #ffffff;
  color: #0b29fb;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  text-decoration: none;
  width: fit-content;
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
    display: block;
  }

  &:hover {
    background: #f5f7ff;
  }
`;

export const SectionCol = styled.div<{ $full?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: ${({ $full }) => ($full ? '1 1 100%' : '1')};
  min-width: 0;
`;

export const SectionIntroText = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #3d3d3d;
`;

export const WhenToContactTitle = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #3d3d3d;
`;

export const WhenToContactList = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #3d3d3d;
`;

export const WhenToContactItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const ContactRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-width: 0;
`;

export const CardContent = styled.div`
  padding: 24px 24px 16px;

  @media (max-width: 600px) {
    padding: 24px 18px 16px;
  }
`;

export const Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const LeftCol = styled.div<{ $full?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex: ${({ $full }) => ($full ? '1 1 100%' : '1')};
  min-width: 0;
`;

export const RightCol = styled.div<{ $full?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  flex: ${({ $full }) => ($full ? '1 1 100%' : '1')};
  min-width: 0;
`;

export const Rule = styled.div`
  flex-shrink: 0;
  width: 0;
  align-self: stretch;
  margin: 0 20px;
  border-left: 1px dashed #d0d0d0;

  @media (max-width: 600px) {
    width: 100%;
    height: 0;
    margin: 20px 0;
    border-left: none;
    border-top: 1px dashed #d0d0d0;
  }
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  flex: 1;
`;

export const DetailTitle = styled.span`
  display: block;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #3d3d3d;
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 22px;
  color: #7a7a7a;
`;

export const Muted = styled.span`
  font-weight: 400;
  color: #262626;
`;

export const Hint = styled.span`
  font-weight: 400;
  font-size: 14px;
  color: #262626;
`;

export const EmailLink = styled.a`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #0b29fb;
  text-decoration-line: underline;
  word-break: break-word;

  &:hover {
    text-decoration-line: underline;
  }
`;

export const SuffixIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: block;
`;

export const ContactIconsGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ContactIconLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  text-decoration: none;
  outline: none;
  cursor: pointer;

  img {
    display: block;
    width: 16px;
    height: 16px;
  }

  &:hover {
    opacity: 0.85;
  }
`;

export const PhoneLink = styled.a`
  font-weight: 400;
  color: #262626;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const Card = styled.div`
  margin-top: 16px;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 24px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

type TableWrapProps = {
  showTour?: boolean;
};

export const TableWrap = styled.div<TableWrapProps>`
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px;
      border-radius: 8px;
    `}
`;

export const IconCircle = styled.div`
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #e5e7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const HeadsetRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-width: 0;
`;

export const HeadsetIcon = styled.img`
  display: block;
  height: 36px;
  width: auto;
  max-width: 26px;
`;

export const SocialMediasTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: #f2f2f2;
  border-radius: 8px;
  box-sizing: border-box;
  width: min(92%, calc(100% - 32px));
  margin-left: auto;
  margin-right: auto;
`;

export const SocialMediaText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: #0b29fb;

  @media (max-width: 600px) {
    text-align: center;
  }
`;

export const SocialFollowRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  padding: 0 24px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    padding: 0 18px;
    text-align: center;
  }
`;

export const SocialIconsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

export const SocialMediaIconLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  text-decoration: none;
  outline: none;

  img {
    display: block;
    height: 42px;
    width: auto;
    max-width: 100%;
  }
`;
